import React from "react";
import { Helmet }  from 'react-helmet'

export default function Player() {
  return (
    <audio
      controls
      autoPlay
      preload="none"
      src="https://radio01.ferozo.com/proxy/ra01001216?mp=/stream"
    />
  );
}
